import {
  MAutocomplete,
  MDatePicker,
  MTextField,
  ResponsiveFormContainer,
} from "@app/components";
import useAnalysis from "@app/pages/samples/utils/useAnalysis";
import { Grid, InputAdornment, Typography } from "@mui/material";
import React, { useEffect } from "react";
import { useFormContext } from "react-hook-form";
import { OPTIONS_YES_NO } from "../iodo131/utils/constants";
import { convertToNumber } from "@app/utils/functions";
import { TYPE_SR } from "./utils/constants";
import useFilteredProcedures from "@app/pages/samples/hook/useFilteredProcedures";

const PrepararionFineForm = () => {
  const form = useFormContext();

  const { currentPreparation } = useAnalysis();
  const regentSelected = form.watch("scintillator_lot_number");
  const filteredProcedures = useFilteredProcedures("PRE", "SFINA");

  useEffect(() => {
    if (regentSelected) {
      form.setValue(
        "carrier_concentration",
        regentSelected.concentration || "",
        { shouldValidate: true }
      );
    }
  }, [regentSelected]);

  useEffect(() => {
    const planchette = convertToNumber(form.watch("planchette")) || 0;
    const planchetteWithPrecipitate =
      convertToNumber(form.watch("planchette_with_precipitate")) || 0;
    const mgTorta = (planchetteWithPrecipitate - planchette) * 1000;
    form.setValue("mg_torta", mgTorta.toFixed(2), { shouldValidate: true });

    const preparation_performance =
      mgTorta / (form.watch("carrier_concentration") * 1.684744) || 0;
    form.setValue("preparation_performance", preparation_performance.toFixed(3));
  }, [
    form.watch("planchette"),
    form.watch("planchette_with_precipitate"),
    form.watch("preparation_performance"),
    form.watch("scintillator_lot_number"),
  ]);

  return (
    <>
      <Grid item xs={12} my={2}>
        <Typography variant="tagText">{TYPE_SR[1].label}</Typography>
      </Grid>
      <ResponsiveFormContainer columns={5}>
        <MAutocomplete
          key={JSON.stringify(form.getValues("preparation_procedure"))}
          name="preparation_procedure"
          options={filteredProcedures}
          label="Procedimiento MLPMA"
          getOptionLabel={(option) => `${option.numop}` || ""}
        />
        <MDatePicker
          name="start_date_precipitation"
          pickerType="datetime"
          label={"Fecha y hora de precipitación"}
          validation={{
            required: "La fecha es requerida",
          }}
          disabled={!currentPreparation.canEdit}
        />
        <MTextField
          name="planchette"
          placeholder={"Plancheta"}
          label={"Plancheta"}
          type="number"
          fullWidth
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">{"(g)"}</InputAdornment>
            ),
          }}
          disabled={!currentPreparation.canEdit}
        />
        <MTextField
          name="planchette_with_precipitate"
          placeholder={"Plancheta con precipitado"}
          label={"Plancheta con precipitado"}
          type="number"
          fullWidth
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">{"(g)"}</InputAdornment>
            ),
          }}
          disabled={!currentPreparation.canEdit}
        />
        <MTextField
          name="mg_torta"
          placeholder="mg de torta SrCO3"
          label="mg de torta SrCO3"
          type="number"
          fullWidth
          disabled
        />

        <MTextField
          name="preparation_performance"
          placeholder="Rendimiento"
          label="Rendimiento"
          type="number"
          fullWidth
          disabled
          //disabled={!currentPreparation.canEdit}
        />

        <MAutocomplete
          key={JSON.stringify(
            form.getValues("yellow_precipitate_silver_nitrate")
          )}
          name="yellow_precipitate_silver_nitrate"
          options={OPTIONS_YES_NO}
          label="¿Ha habido formación de precipitado amarillo añadir nitrato de plata?"
          getOptionLabel={(option) => option.label}
          disabled={!currentPreparation.canEdit}
        />
      </ResponsiveFormContainer>
    </>
  );
};

export default PrepararionFineForm;
